import * as Yup from 'yup';
import { TimeZoneConstants } from './constants';

const useTimeZone = ({ setFilters }) => {
  const timeZoneOptions = TimeZoneConstants.map((item) => ({
    label: item.label,
    value: item.value,
  }));

  const formSchema = Yup.object().shape({
    tzAbbreviation: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      }),
    ),
  });

  const onSubmit = ({ tzAbbreviation }) => {
    setFilters({ tzAbbreviation });
  };

  return { timeZoneOptions, onSubmit, formSchema };
};

export default useTimeZone;
